import styled from 'styled-components'
import {
    PersonOutline as PersonOutlineIcon,
    CalendarTodayOutlined as CalendarTodayOutlinedIcon,
    HourglassEmptyOutlined as HourglassEmptyOutlinedIcon,
    LocationOnOutlined as LocationOnOutlinedIcon
} from '@material-ui/icons';
import { Button } from '@material-ui/core';

import ProImage from "components/Icons/ProImage";
import EliteImage from "components/Icons/EliteImage";

export const Container = styled.div`
  height: auto;
  padding-bottom: 1rem;
  overflow-y: visible;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;

  margin-top: 1rem;
  width: 100%;
  max-width: 100%;

  @media(min-width: 768px) {
    margin-top: 1rem;
  }
`

export const JobContainer = styled.div<{ $isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin: 0.75rem 0;
  background-color: ${({ $isActive }) => $isActive ? 'var(--background-success, #F1F7FF)':'var(--background-info, #F7F7F7)'}; 
  padding: 1.25rem;
  border-radius: 16px;
  max-width: 100%;

  /* Featured (Displayed) highlight, parity with temping boosted styling */
  &.featuredDisplayed {
    background-color: #fff;
    border: 2px solid var(--primary-blue, #0B4598);
    box-shadow: 0 2px 10px rgba(11, 69, 152, 0.08);
  }

  &:first-child {
    margin-top: 0;
  }
  
  &:last-child {
    margin-bottom: 1rem;
  }
  
  @media(min-width: 768px) {
    padding: 1.5rem;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

export const JobDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const TitlesContainer = styled.div` 
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 1rem;
  width: 100%;
`

export const Title = styled.div`
  font-size: var(--typography-h6-size, 1.25rem);
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 0.25rem;
  
  @media(min-width: 768px) {
    font-size: 1.375rem;
  }
`

export const Subtitle = styled.div`
  display: flex;
  align-items: center;
  font-size: var(--typography-body-1-bold-size, 1rem);
  line-height: 1.4;
  flex-wrap: wrap;
  gap: 0.35rem;
`

export const NewCandidatesInfo = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.45rem;
  color: #fff;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 9999px;
  background-color: #13CA82;
  flex: 0 0 auto;

  @media (max-width: 465px) {
    margin-left: 0.25rem;
    font-size: 0.7rem;
  }
`

export const CandidateInfo = styled.div`
  font-weight: bold;
  color: var(--info-main, #0288D1);
  font-size: var(--typography-body-1-bold-size, 1rem);
`

export const PendingJobInfo = styled.div`
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  color: #fff;
  font-weight: 500;
  font-size: 0.75rem;
  border-radius: 0.5rem;
  background-color: #988C81FF;
  margin-left: 1rem;
  min-width: auto;

  @media (max-width: 465px) {
    margin-left: 0.5rem;
    font-size: 0.65rem;
  }
`

export const PersonOutlineIconStyled = styled(PersonOutlineIcon)`
  margin-right: 0.25rem;
  height: 16px;
  width: 16px;
`

export const PersonOutlineIconInColorStyled = styled(PersonOutlineIconStyled)`
  color: #0B4598;
  text-align: start;
`

export const HourglassEmptyOutlinedIconStyled = styled(HourglassEmptyOutlinedIcon)`
  color: #fff;
  height: 18px;
`

export const CalendarTodayOutlinedIconStyled = styled(CalendarTodayOutlinedIcon)`
  font-size: var(--typography-body-1-bold-size, 1rem);
  margin: 0 0.25rem;
  color: #0B4598;
`

export const LocationOnOutlinedIconStyled = styled(LocationOnOutlinedIcon)`
  font-size: var(--typography-body-1-bold-size, 1rem);
  margin 0 0.25rem;
  color: #0B4598;
`

export const StartingDate = styled.span<{ $isHygienist?: boolean }>`
  font-size: 0.85rem;
  color: #666;
  margin-left: ${({ $isHygienist }) => $isHygienist ? '0.25rem' : '0'};

  @media (max-width: 465px) {
    font-size: 0.8rem;
  }
`

export const PostedOnText = styled.span`
  font-size: 0.85rem;
  color: #666;
  margin-left: 0.25rem;
  @media (max-width: 465px) {
    font-size: 0.8rem;
  }
`;

export const JobInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.25rem 1rem;
  width: 100%;

  @media(min-width: 420px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }
`

export const JobInfoItem = styled.div`
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr);
  align-items: center;
  column-gap: 0.4rem;
  color: var(--info-main, #0288D1);
  font-size: 0.875rem;

  b {
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 600;
  }

  span { white-space: normal; overflow: visible; text-overflow: unset; }

  @media (max-width: 465px) {
    width: 100%;
    column-gap: 0.35rem;
  }
`

export const Badge = styled.div`
  margin-left: 0.25rem;
  display: inline-flex;
  align-items: center;
`;

export const FeaturedBadge = styled.span`
  margin-left: 8px;
  color: var(--primary-blue, #0B4598);
  font-weight: 600;
  background: #fff;
  border: 2px solid rgba(11,69,152,0.35);
  border-radius: 6px;
  padding: 2px 6px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const StyledProImage = styled(ProImage)`
  height: 16px !important;
  width: auto !important;
`

export const StyledEliteImage = styled(EliteImage)`
  height: 16px !important;
  width: auto !important;
`

export const RepostButton = styled(Button)`
  &.MuiButton-root {
    font-weight: 600;
    flex-shrink: 0;
    /* T2-6756: column layout on mobile — space below job details; row keeps left gap on desktop */
    margin-top: 1rem;
    margin-left: 0;

    @media (min-width: 768px) {
      margin-top: 0;
      margin-left: 1rem;
    }
  }
`;
